import { OAuthClient } from '@recruitee/http-types';
import { createEntityCollectionStore, PickActions } from '@recruitee/ngrx';

const { actions, reducer, namespace, selectors } =
  createEntityCollectionStore<OAuthClient>()('OAuthClient');

const OAuthClientActions: PickActions<typeof actions, 'fetchOne'> = actions;

export {
  OAuthClientActions,
  reducer as OAuthClientReducer,
  namespace as OAuthClientNamespace,
  selectors as OAuthClientSelectors,
};
